import { METHOD } from 'services/method'

export const API_AWARD = {
    NOMINATION_BANNER: {
        api: '/v1/dashboard-admin/award/nomination-page/banner',
        method: METHOD.GET,
    },
    NOMINATION_CATEGORY: {
        api: '/v1/dashboard-admin/award/nomination-page/category',
        method: METHOD.GET,
    },
    NOMINATION_BRAND: {
        api: '/v1/dashboard-admin/award/nomination-page/brand',
        method: METHOD.GET,
    },
    NOMINATION_VIDEO: {
        api: '/v1/dashboard-admin/award/nomination-page/video',
        method: METHOD.GET,
    },

    THANK_YOU_PAGE: {
        api: '/v1/dashboard-admin/award/thank-you-page',
        method: METHOD.GET,
    },

    URL_AWARD_IMAGE: {
        api: '/v1/dashboard-admin/award/storage-url/attachment',
        method: METHOD.POST,
    },

    WINNER_VIDEO: {
        api: '/v1/dashboard-admin/award/winner-page/video',
        method: METHOD.GET,
    },
    WINNER_CATEGORY: {
        api: '/v1/dashboard-admin/award/winner-page/category',
        method: METHOD.GET,
    },
    WINNER_BRAND: {
        api: '/v1/dashboard-admin/award/winner-page/brand',
        method: METHOD.GET,
    },

    CATEGORY_LIST: {
        api: '/v1/dashboard-admin/award/category',
        method: METHOD.GET,
    },
    CATEGORY_CREATE: {
        api: '/v1/dashboard-admin/award/category',
        method: METHOD.POST,
    },
    CATEGORY_UPDATE: {
        api: '/v1/dashboard-admin/award/category',
        method: METHOD.PUT,
    },
    CATEGORY_DELETE: {
        api: '/v1/dashboard-admin/award/category/bulk-delete',
        method: METHOD.POST,
    },

    BRAND_LIST: {
        api: '/v1/dashboard-admin/award/nominee/brand',
        method: METHOD.GET,
    },
    BRAND_CREATE: {
        api: '/v1/dashboard-admin/award/nominee/brand',
        method: METHOD.POST,
    },
    BRAND_UPDATE: {
        api: '/v1/dashboard-admin/award/nominee/brand',
        method: METHOD.PUT,
    },
    BRAND_DELETE: {
        api: '/v1/dashboard-admin/award/nominee/brand/bulk-delete',
        method: METHOD.POST,
    },

    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/award/nominee/product',
        method: METHOD.GET,
    },
    PRODUCT_CREATE: {
        api: '/v1/dashboard-admin/award/nominee/product',
        method: METHOD.POST,
    },
    PRODUCT_UPDATE: {
        api: '/v1/dashboard-admin/award/nominee/product',
        method: METHOD.PUT,
    },
    PRODUCT_DELETE: {
        api: '/v1/dashboard-admin/award/nominee/product/bulk-delete',
        method: METHOD.POST,
    },

    AWARD_LIST: {
        api: '/v1/dashboard-admin/award/list',
        method: METHOD.GET,
    },
    AWARD_DETAIL: {
        api: '/v1/dashboard-admin/award',
        method: METHOD.GET,
    },
    AWARD_CREATE: {
        api: '/v1/dashboard-admin/award',
        method: METHOD.POST,
    },
    AWARD_UPDATE: {
        api: '/v1/dashboard-admin/award',
        method: METHOD.PUT,
    },
    AWARD_COMPLETE: {
        api: '/v1/dashboard-admin/award/complete',
        method: METHOD.POST,
    },
    AWARD_ANALYTIC: {
        api: '/v1/dashboard-admin/award/analytics',
        method: METHOD.GET,
    },
    AWARD_ANALYTIC_EXPORT: {
        api: '/v1/dashboard-admin/award/analytics/export',
        method: METHOD.POST,
    },
}
